import Vue from 'vue'

import ActionCableVue from "actioncable-vue"; // Rails default includes

// Components
import ImporterProgressBar from "../components/backend/ImporterProgressBar";
import ImageSelector from "../components/backend/ImageSelector";
import CampaignTemplateSelector from "../components/backend/CampaignTemplateSelector"
import CampaignControls from "../components/backend/CampaignControls"
import Live from "../components/backend/Live";
import VoterSecrets from "../components/backend/VoterSecrets"
import TranslationsEditor from "../components/backend/TranslationsEditor"
import MessageLocalContent from "../components/backend/messages/MessageLocalContent";
import AllowedDomains from "../components/backend/election_config/access/AllowedDomains";

import i18n from "./shared/i18n";
import store from './frontend/store';
import bsTooltip from './shared/bs-tooltips' // Needs to be "called" here to instantiate methods for hover tooltips

const ImporterProgressBarComponentClass = Vue.extend(ImporterProgressBar)
const ImageSelectorComponentClass = Vue.extend(ImageSelector)
const CampaignTemplateSelectorComponentClass = Vue.extend(CampaignTemplateSelector)
const CampaignControlsComponentClass = Vue.extend(CampaignControls)
const LiveComponentClass = Vue.extend(Live)
const VoterSecretsComponentClass = Vue.extend(VoterSecrets)
const TranslationsEditorComponentClass = Vue.extend(TranslationsEditor)
const MessageLocalContentComponentClass = Vue.extend(MessageLocalContent)
const AllowedDomainsComponentClass = Vue.extend(AllowedDomains)

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'all'
})



$(function(){

  $('[data-vue-component="importer-progress-bar"]').each(function(){
    let propsData = $(this).data('vue-props')
    let importerProgress = new ImporterProgressBarComponentClass({propsData: propsData, i18n: i18n})
    importerProgress.$mount()
    this.appendChild(importerProgress.$el)
  })

  $('[data-vue-component="translations-editor"]').each(function(){
    let propsData = $(this).data('vue-props')
    let translationsEditor = new TranslationsEditorComponentClass({propsData: propsData, i18n: i18n})
    translationsEditor.$mount()
    this.appendChild(translationsEditor.$el)
  })

  $('[data-vue-component="voter-secrets"]').each(function(){
    let propsData = $(this).data('vue-props')
    let voterSecrets = new VoterSecretsComponentClass({propsData: propsData, i18n: i18n})
    voterSecrets.$mount()
    this.appendChild(voterSecrets.$el)
  })

  $('[data-vue-component="image-selector"]').each(function(){
    let propsData = $(this).data('vue-props')
    let imageSelector = new ImageSelectorComponentClass({propsData: propsData, i18n: i18n})
    imageSelector.$mount()
    this.appendChild(imageSelector.$el)
  })

  $('[data-vue-component="campaign-template-selector"]').each(function(){
    let propsData = $(this).data('vue-props')
    let templateSelector = new CampaignTemplateSelectorComponentClass({propsData: propsData, i18n: i18n})
    templateSelector.$mount()
    this.appendChild(templateSelector.$el)
  })

  $('[data-vue-component="campaign-controls"]').each(function(){
    let propsData = $(this).data('vue-props')
    let campaignControls = new CampaignControlsComponentClass({propsData: propsData, i18n: i18n})
    campaignControls.$mount()
    this.appendChild(campaignControls.$el)
  })

  $('[data-vue-component="message-local-content"]').each(function(){
    let propsData = $(this).data('vue-props')
    let messageLocalContent = new MessageLocalContentComponentClass({propsData: propsData, i18n: i18n})
    messageLocalContent.$mount()
    this.appendChild(messageLocalContent.$el)
  })

  // Election config
  $('[data-vue-component="access/allowed-domains"]').each(function(){
    let propsData = $(this).data('vue-props')
    let allowedDomains = new AllowedDomainsComponentClass({propsData: propsData, i18n: i18n})
    allowedDomains.$mount()
    this.appendChild(allowedDomains.$el)
  })

  $('[data-vue-component="live"]').each(async function(){
    let electionTitle = JSON.parse(this.getAttribute('data-title'))
    let electionLogo = this.getAttribute('data-logo')
    let electionId = this.getAttribute('data-id')
    let electionSlug = this.getAttribute('data-slug')
    let electionUrl = this.getAttribute('data-url')
    let electionLocales = JSON.parse(this.getAttribute('data-locales'))
    let readonly = this.getAttribute('data-readonly') === "true"

    window.onunhandledrejection = event => {
      let error = event.reason;
      if(!error.response){
        // display connection warning
        store.commit('connectionFailed')
        event.preventDefault()
      } else if(error.response.status === 401 && [11].includes(error.response.data.code)) { // [11: invalidAuthenticityToken]
        // the admin's authenticity token has expired (likely because their session has expired)
        if(confirm(i18n.$t('js.backend.live.invalid_authenticity_token_confirm_reload'))){
          window.location.reload()
        }
        event.preventDefault()
      } else if(error.response.status === 403) {
        store.commit('showToast', {header: i18n.t('js.toasts.error.request_denied'), body: error.response.data.message, duration: 5, classes: {header: 'bg-danger text-white'}})
        event.preventDefault()
      }
    }

    store.commit('setElectionUrl', { electionUrl })
    store.commit('setSlides', [])
    store.commit('setLocales', electionLocales)
    store.commit('setElection', {
      id: electionId,
      title: electionTitle,
      logo: electionLogo,
      slug: electionSlug,
      userModules: {}
    });
    store.commit('setReadonly', readonly)

    const { default: router } = await import('./live_router')
    let live = new LiveComponentClass({store, i18n, router})
    live.$mount()
    this.appendChild(live.$el)
  })
})

$(function(){
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
})
